import EditGallerySidePane from "./EditGallerySidePane";

export default EditGallerySidePane;
